import { useContext } from 'react';

import { Guard } from './guard';
import { UserContext } from '../user/User.context';

export default function AuthGuard(): Guard {
  const { user } = useContext(UserContext);
  return { canActivate: () => !!user };
}
